import { Form, Formik } from "formik";
import validationSchema from "../../../../Validation/ValidationSchemas";
import UploadVideoForm from "../../Upload Video/UploadVideoForm";
import { useSelector } from "react-redux";
import { useRef } from "react";
import { useDispatch } from "react-redux";

const SeasonInformation = ({ page, setPage }) => {
  const dispatch = useDispatch();
  const seasonRef = useRef();
  const currentSeason = useSelector(
    (state) => state?.loggedInUser?.userProfile?.currentSeason
  );
  const videoScheduleInformation = useSelector(
    (state) => state?.videoScheduleInformation
  );

  return (
    <div>
      <div className="video-streaming-season-info shadow">
        <Formik
          initialValues={{
            uploadvideoEvent: videoScheduleInformation?.uploadvideoEvent,
            uploadVideoWeek: videoScheduleInformation?.uploadVideoWeek,
            uploadVideoWeekName: videoScheduleInformation?.uploadVideoWeekName,
            uploadVideoEventType:
              videoScheduleInformation?.uploadVideoEventType,
            uploadVideoOffSeasonEventName:
              videoScheduleInformation?.uploadVideoOffSeasonEventName,
            otherEventName: videoScheduleInformation?.otherEventName,
            practice: videoScheduleInformation?.practice,
          }}
          enableReinitialize
          validationSchema={validationSchema.UploadVideoSchema}
          innerRef={seasonRef}
          onSubmit={() => setPage((page) => page + 1)}
        >
          {(formik) => (
            <Form>
              {currentSeason?.years == null ? (
                <p className="fs-20 bold d-flex align-items-center justify-content-center">
                  Please Create Season First
                </p>
              ) : (
                <>
                  <p className="fs-20 bold">{`${currentSeason?.years} Season`}</p>
                  <UploadVideoForm formik={formik} />
                  <div className="d-flex-center gap-20 mg-top-20">
                    <button
                      className="saveBtn1"
                      onClick={() => setPage((page) => page - 1)}
                    >
                      Back
                    </button>
                    <button
                      className={`${
                        !formik.isValid ? "saveBtn1 activv" : "saveBtn1"
                      } position-relative d-flex-center blur-filter-background z-0`}
                      disabled={!formik.isValid}
                      type="submit"
                    >
                      Next
                    </button>
                  </div>
                </>
              )}
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default SeasonInformation;
